import {currencies} from 'constants/currencies';
import * as yup from 'yup';

const validCurrencyCodes = currencies.map(c => c.code);

export const customerDetailsSchema = yup.object({
  firstName: yup.string().trim().required('First name is required'),
  lastName: yup.string().trim().required('Last name is required'),
  username: yup.string().trim().required('Last name is required'),
  email: yup
    .string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Invalid email format',
    )
    .required('Email is required'),
  phoneNumber: yup
    .number()
    .typeError('Phone number must be a number')
    .required('Phone number is required'),
  city: yup.string().trim().required('City is required'),
  state: yup.string().trim().required('State is required'),
  country: yup.string().trim().required('Country is required'),
  currency: yup
    .string()
    .oneOf(validCurrencyCodes, 'Invalid currency selection')
    .required('Currency is required'),
  postalCode: yup
    .string()
    .matches(/^\d+$/, 'Postal code must be numeric')
    .required('Postal code is required'),
  streetName: yup.string().trim().required('Street name is required'),
  houseNumber: yup.string().trim().required('House number is required'),
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters long')
    .required('Password is required'),

  // Business details
  businessName: yup.string().trim().required('Business name is required'),
  businessCategory: yup
    .string()
    .trim()
    .required('Business category is required'),
  businessContactNumber: yup
    .number()
    .typeError('Business contact number must be a number')
    .required('Business contact number is required'),
  businessWebsiteURL: yup.string().url('Invalid website URL').nullable(),
  businessTaxNumber: yup.string().trim().required('Tax number is required'),
  businessCountry: yup.string().trim().required('Business country is required'),
  businessState: yup.string().trim().required('Business state is required'),
  businessCity: yup.string().trim().required('Business city is required'),
  businessStreetName: yup
    .string()
    .trim()
    .required('Business street name is required'),
  businessHouseNumber: yup
    .string()
    .trim()
    .required('Business house number is required'),
  businessPostalCode: yup
    .string()
    .matches(/^\d+$/, 'Business postal code must be numeric')
    .required('Business postal code is required'),
});
